import {
    useToast,
} from '@chakra-ui/react';
import { useRef } from 'react';
import { EmailType } from '@acp/shared';
import { useInvoiceForward } from '../hooks/use-invoice-forward';
import { ForwardEmailFormValues } from '../../email';
import { SendEmailModalRef } from '../../../components/forms';
import { SendEmailModal } from '../../../components/modals';

export function ForwardInvoiceModal({
    isOpen,
    onClose,
    propertyId,
    invoiceId,
}: {
    isOpen: boolean;
    onClose: () => void;
    propertyId: number;
    invoiceId: number;
}) {
    const formRef = useRef<SendEmailModalRef>(null);
    const toast = useToast();

    const forwardInvoiceMutation = useInvoiceForward({
        onSuccess: () => {
            toast({
                title: 'Invoice email forwarded',
                description: 'The specified recipient(s) should receive the email shortly.',
                status: 'success',
                isClosable: true,
            });

            formRef.current?.resetForm();
            onClose();
        },
    });

    const handleClose = () => {
        forwardInvoiceMutation.reset();
        onClose();
    };

    const onSubmit = (vals: ForwardEmailFormValues) => {
        forwardInvoiceMutation.mutate({
            invoiceId,
            toAddresses: vals.toEmails.map((email) => email.value),
            ccAddresses: vals.ccEmails.map((email) => email.value),
            message: vals.emailMessage,
        });
    };

    return (
        <SendEmailModal
            ref={formRef}
            title="Forward invoice"
            propertyId={propertyId}
            mutation={forwardInvoiceMutation}
            onClose={handleClose}
            onSubmit={onSubmit}
            isOpen={isOpen}
            extraErrorMessage="We were unable to forward this invoice"
            includeLandlords
            includePropertyManagers
            previewAvailable
            metaData={{
                emailType: EmailType.FORWARD_INVOICE,
                propertyId,
                invoiceId,
            }}
        />
    );
}
